import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { selectIsMyPlayerIn } from '../../../../redux/reducers/pokerReducer';
import { useAppSelector } from '../../../../redux/store';
import { isTestEnvironment } from '../../../../utils/utils';
import { LiveCommunityCardDisplay } from './liveCommunityCardDisplay';
const PIXI_DATA = isTestEnvironment() ? { type: 'community-cards' } : null;
export const LiveCommunityCardsContainer = ({ x, y, allCardRenderProperties }) => {
    const isIn = useAppSelector(selectIsMyPlayerIn);
    const isFourColorDeckEnabled = useAppSelector((state) => state.selfData.isFourColorDeckEnabled);
    return (_jsx(Container, { "pixi-data": PIXI_DATA, x: x, y: y, children: allCardRenderProperties.map((cardRenderProperties, i) => (_jsx(LiveCommunityCardDisplay, { communityCardIndex: i, cardRenderProperties: cardRenderProperties, isIn: isIn, isFourColorDeckEnabled: isFourColorDeckEnabled }, i))) }));
};
